import JLibChartCustoms       from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/00_Customs'
import JLibChartDonut         from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/01_Donut'
import JLibChartPie           from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/02_Pie'
import JLibChartBarAxis       from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/03_Bar_Normal'
import JLibChartBarSolid      from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/04_Bar_Solid'
import JLibChartBarProgress   from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/00_System/Progress'
import JLibChartSummary       from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/00_System/Summary'
import JLibChartWeekly        from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/00_System/Week'
import JLibChartBarDelta      from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/06_Bar_Delta'
import JLibChartHistogram     from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/06_Histogram'
import JLibChartRadar         from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/07_Radar'
// import JLibChartSkyline       from '../../lib/jin/jwchartlib-v0/lib/Components/Z_PageComponents/03_Skylines'
// import JLibChartTableSummary  from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Charts/00_System/Summary_Table_Dep2'
import JLibComponentSvg       from '../../lib/jin/jwchartlib-v0/lib/Components/Z_PageComponents/00_Customs'

// svg3 jwcnioos Project
// import JLibV2ComponentSvg from '../../lib/jin/svgchartlib-v3/export/jwcnioos_index'
// svg3 Component
import JLibV2ChartCustoms     from '../../lib/jin/jwchartlib-v0/export/Component_index'

export default {
  ...JLibChartCustoms,
  ...JLibV2ChartCustoms,
  JLibChartDonut,
  JLibChartPie,
  JLibChartBarAxis,
  JLibChartBarSolid,
  JLibChartBarProgress,
  JLibChartSummary,
  JLibChartWeekly,
  JLibChartBarDelta,
  JLibChartHistogram,
  JLibChartRadar,
  // JLibChartSkyline,
  // JLibChartTableSummary,
  ...JLibComponentSvg,  
  // ...JLibV2ComponentSvg,
}
